jQuery(document).ready(function($) {
    $('#search-clinic-form').on('submit', function(e, page) {
        e.preventDefault();

        var keywords = $('#search-clinic').val();
        page = page || 1; // default to page 1 if no page is passed

        $.ajax({
            url: ajax_callback_data.ajax_url,
            type: 'POST',
            data: {
                action: 'clinic_search',
                keywords: keywords,
                paged: page,
                nonce: ajax_callback_data.ajax_nonce
            },
            beforeSend: function() {
                $('.clinics_wrapper').find('.row').html('<p>Loading...</p>');
            },
            success: function(response) {
                $('.clinics_wrapper').find('.row').html(response.data.content);
                $('.pagination').html(response.data.pagination);
            },
            error: function() {
                $('.clinics_wrapper').find('.row').html('<p>Something went wrong. Please try again.</p>');
            }
        });
    });
});
// Handel pagination
jQuery(document).on('click', '.pagination a', function(e){
    e.preventDefault();

    var href = jQuery(this).attr('href');
    var page = 1;

    // Match the page number at the end of the URL: /page/2/
    var match = href.match(/\/page\/(\d+)\//);
    if(match) {
        page = match[1];
    }

    // Trigger AJAX search with the correct page
    jQuery('#search-clinic-form').trigger('submit', [page]);
});